import { InstalledApplicationsState } from './installed-applications.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInstalledApplications from './installed-applications.reducer';

export const selectInstalledApplicationsState =
  createFeatureSelector<InstalledApplicationsState>('installed-applications');

export const selectAllInstalledApplications = createSelector(
  selectInstalledApplicationsState,
  fromInstalledApplications.selectAllInstalledApplications
);

export const selectDistinctBundleIdentifiers = createSelector(
  selectAllInstalledApplications,
  (installedApplications) => {
    return Array.from(new Set(installedApplications.map((app) => app.bundleIdentifier)));
  }
);

export const selectDistinctBundleIdentifiersPerLocation = (locationId: string) =>
  createSelector(selectAllInstalledApplications, (installedApplications) => {
    return Array.from(
      new Set(installedApplications.filter((app) => app.locationId === locationId).map((app) => app.bundleIdentifier))
    );
  });
